// extracted by mini-css-extract-plugin
export default {"labelText":"styles_labelText__RetAN"};